// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__v0y4V","inputWrap":"Table_inputWrap__1L2eT","col":"Table_col__N8_TH","bmiTooltip":"Table_bmiTooltip__21AR-"};